<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.applicationType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['applyType',{'initialValue':'10'}]" :trigger-change="true" dictCode="sqlx" placeholder="请选择申请类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" @change="handleFarmerChange" v-decorator="['farmCode',validatorRules.farmCode]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'" :placeholder="$t('label.pleaseSelectFarms')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" @change="handleBreedBatchCodeChange" v-decorator="['breedBatchCode',validatorRules.breedBatchCode]" :trigger-change="true" :dictCode="dictBreedBatchCode"  :placeholder="$t('label.pleaseSelectTheFeedingLot')"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['farmerCode',validatorRules.farmerCode]" :trigger-change="true" :dictCode="dictFarmerCode" :placeholder="$t('label.pleaseSelectGrower')" />
            </a-form-item>
          </a-col>
          <a-col :span="24" >
            <a-form-item :label="$t('label.feedingCycle')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled  v-decorator="['breedCycleWeeks']"  :dictCode="dictBreedCycle" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="入雏数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['housingQty']" placeholder="请输入入雏数量" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="当前存栏数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['currentStockQty']" placeholder="请输入当前存栏数" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.applicant')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                :triggerChange="true"
                dictCode="sys_user,realname,username,del_flag = '0'"
                v-decorator="['applicant', {'initialValue': initApplyUser, rules: validatorRules.applicant.rules}]"
              />
              <!--<a-input v-decorator="['applicant']" placeholder="请输入申请人"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.documentDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectDocumentDate')" v-decorator="['applyTime',{'initialValue': initAccountPeriod, rules: validatorRules.applyTime.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="申请原因" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['applyReason',validatorRules.applyReason]" placeholder="请输入申请原因"></a-input>
            </a-form-item>
          </a-col>
         <!-- <a-col :span="24">
            <a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx" placeholder="请选择是否有效"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-item v-has="'lastApprover'"  label="最后审批人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lastApprover']" placeholder="请输入最后审批人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item v-has="'lastApproveTime'"  label="最后审批时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择最后审批时间" v-decorator="['lastApproveTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import { getCurrentUser } from '@api/api'
  import moment from "moment"

  export default {
    name: 'EfsStlSettleApplyForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
            farmCode: {
                rules: [
                    { required: true, message: '请选择养殖场!'},
                ]
            },
            breedBatchCode: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectTheFeedingLot')},
                ]
            },
            farmerCode: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectGrower')},
                ]
            },
            applicant: {
                rules: [
                    { required: true, message: '请选择申请人!'},
                ]
            },
            applyTime: {
                rules: [
                    { required: true, message: this.$t('label.pleaseSelectDocumentDate')},
                ]
            },
            applyReason: {
                rules: [
                    { required: true, message: '请输入申请原因!'},
                ]
            },
        },
        url: {
          add: "/specialSettleApply/efsStlSettleApply/add",
          edit: "/specialSettleApply/efsStlSettleApply/edit",
          queryById: "/specialSettleApply/efsStlSettleApply/queryById",
          queryByConCode: '/batchManage/efsMdBreedBatch/queryByBatchCodeNew'
        },
          dictFarmerCode:"",
          dictBreedBatchCode:"",
          dictBreedCycle:"",
          initApplyUser: null,
          initAccountPeriod: moment(new Date()).format('YYYY-MM-DD')
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
        getCurrentUser().then((res) => {
            if (res.success) {
                this.initApplyUser = res.result.username;
            }
        });
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
          if(this.model.id){
              this.dictFarmerCode = "efs_md_farmer,name,code, code = (SELECT t2.farmer_code FROM sys_depart AS t1 LEFT JOIN sys_depart_extend AS t2 ON t1.id = t2.id WHERE t1.org_code ='" + this.model.farmCode + "') and del_flag = 'N'";
              this.dictBreedBatchCode="efs_md_breed_batch,name,code, farm_code = '" + this.model.farmCode + "' and del_flag = 'N'";
          }else {
              this.model.farmerCode = '';
              this.model.breedBatchCode = '';
          }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'applyType','farmCode','breedBatchCode','farmerCode','housingQty','currentStockQty','applicant','applyTime','lastApprover','lastApproveTime','applyReason','validFlag','breedCycleWeeks'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'applyType','farmCode','breedBatchCode','farmerCode','housingQty','currentStockQty','applicant','applyTime','lastApprover','lastApproveTime','applyReason','validFlag','breedCycleWeeks'))
      },
        handleFarmerChange(value) {
            this.dictFarmerCode = "efs_md_farmer,name,code, code = (SELECT t2.farmer_code FROM sys_depart AS t1 LEFT JOIN sys_depart_extend AS t2 ON t1.id = t2.id WHERE t1.org_code ='" + value + "') and del_flag = 'N'";
            this.dictBreedBatchCode="efs_md_breed_batch,name,code, farm_code = '" + value + "' and del_flag = 'N'";
            this.model.farmerCode = ''
            this.model.breedBatchCode = ''
            this.form.setFieldsValue({
                breedCycleWeeks: ""
            });
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'farmerCode','breedBatchCode'))
            })
        },
        handleBreedBatchCodeChange(value) {
            this.form.setFieldsValue({
                breedCycleWeeks: ""
            });
            getAction(this.url.queryByConCode, { code: value }).then(res => {
                if (res.success) {
                    this.form.setFieldsValue({
                        breedCycleWeeks: res.result.batchCycle
                    })
                } else {
                    this.$message.warning(res.message)
                }
            })
        },
    }
  }
</script>